export const ROOMS = '/rooms';
export const ROOMS_LOCATION = '/:location/:placeId/rooms';
export const PROFILE = '/profile';
export const BOOKING_INFO = '/booking-info'
// export const BOOKING_INFO = '/payment'
export const HOTEL_DETAIL = '/hotel/:slug/detail'
